<div class="flyout-campaign-information-component" #flyoutCampaignInformationComponent>
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="!expandedTab || expandedTab === 'campaign-information'" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <img class="header-icon" src="/assets/img/icons_fl/onsite%20campaigns%202.svg" width="32px" height="32px" />
        <span>{{ "flyout.campaign-info.onsite-campaigns-title" | translate }}</span>
      </mat-expansion-panel-header>

      <div class="expansion-panel-row header">
        <div class="label name" (click)="sortByProperty('campaignName')">
          <span class="clickable">{{ "flyout.name" | translate }}</span>
          @if (sortingProperty === "campaignName") {
            <span class="sorting-icon-item clickable">
              @if (sortingDirection === 1) {
                <mat-icon>arrow_drop_up</mat-icon>
              }
              @if (sortingDirection === -1) {
                <mat-icon>arrow_drop_down</mat-icon>
              }
            </span>
          }
        </div>
        <div class="label value-label" (click)="sortByProperty('count')">
          <span class="clickable">{{ "flyout.count" | translate }}</span>
          @if (sortingProperty === "count") {
            <span class="sorting-icon-item clickable">
              @if (sortingDirection === 1) {
                <mat-icon>arrow_drop_up</mat-icon>
              }
              @if (sortingDirection === -1) {
                <mat-icon>arrow_drop_down</mat-icon>
              }
            </span>
          }
        </div>
      </div>

      @for (event of ocEventsToShow; track event) {
        <div class="expansion-panel-row values">
          <div class="column content">
            <div class="content-row text">
              <div class="icon-column">
                @if (event.type === OnsiteCampaignEventType.WidgetOpen) {
                  <ng-container class="label">
                    <mat-icon>visibility</mat-icon>
                  </ng-container>
                }
                @if (event.type === OnsiteCampaignEventType.WidgetClickThrough) {
                  <ng-container class="label">
                    <mat-icon>mouse</mat-icon>
                  </ng-container>
                }
                @if (event.type === OnsiteCampaignEventType.CopyCoupon) {
                  <ng-container class="label">
                    <app-tb-icon [icon]="'tb:discount-code'" [isImage]="false"></app-tb-icon>
                  </ng-container>
                }
                @if (event.type === OnsiteCampaignEventType.WidgetConversion || event.type === OnsiteCampaignEventType.SurveyResponse) {
                  <ng-container class="label">
                    <div class="icon">
                      <img src="/assets/img/medal.svg" />
                    </div>
                  </ng-container>
                }
              </div>
              <div class="text-column">
                @if (event.type === OnsiteCampaignEventType.WidgetOpen) {
                  <ng-container class="label">
                    <span class="label-text">{{ "visits.goalEvents.displayedCampaign" | translate }}:&nbsp;</span>
                  </ng-container>
                }
                @if (event.type === OnsiteCampaignEventType.WidgetClickThrough) {
                  <ng-container class="label">
                    <span class="label-text">{{ "visits.goalEvents.clickThrough" | translate }}:&nbsp;</span>
                  </ng-container>
                }
                @if (event.type === OnsiteCampaignEventType.CopyCoupon) {
                  <ng-container class="label">
                    <span class="label-text">{{ "visits.goalEvents.discount" | translate }}:&nbsp;</span>
                  </ng-container>
                }
                @if (event.type === OnsiteCampaignEventType.WidgetConversion || event.type === OnsiteCampaignEventType.SurveyResponse) {
                  <ng-container class="label">
                    <span class="label-text">{{ "visits.goalEvents.formSubmission" | translate }}:&nbsp;</span>
                  </ng-container>
                }
                @if (event.campaignName && !event.deletedWidget) {
                  <span class="campaign-name link-color" [innerHTML]="event.campaignName" (click)="openWidgetPreview($event, event.id * 1)"></span>
                }
                @if (event.campaignName && event.deletedWidget) {
                  <span class="campaign-name-deleted" [innerHTML]="event.campaignName"></span>
                }
              </div>
              @if (event.count === 1) {
                <span>{{ event.count }}{{ "flyout.consent.time" | translate }}</span>
              }
              @if (event.count > 1) {
                <span>{{ event.count }}{{ "flyout.consent.times" | translate }}</span>
              }
            </div>
          </div>
        </div>
      }
      @if (ocEvents.length > 5) {
        <div class="expansion-panel-row pagination">
          <div class="navigation" (click)="navigateCampaigns(false)">
            <span>
              <mat-icon>arrow_back</mat-icon>
              {{ "generic.previous" | translate }}
            </span>
          </div>
          <span>{{ spanStart }} - {{ spanEnd }} {{ "generic.of" | translate }} {{ ocEvents.length }}</span>
          <div class="navigation" (click)="navigateCampaigns(true)">
            <span>
              {{ "generic.next" | translate }}
              <mat-icon>arrow_forward</mat-icon>
            </span>
          </div>
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
